/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/alt-text */
/** @jsxImportSource @emotion/react */
import { colors, TextItalic } from 'components/landing/ui';

import certificate from '../images/guarantee-certificate.svg';

const GuaranteedResult = ({ children, ...rest }) => (
  <div
    css={{
      alignItems: 'center',
      width: '100%',
      padding: '12px 30px',
      border: `1px solid ${colors.black}`,
      borderRadius: 4,
    }}
    {...rest}
  >
    <img src={certificate} css={{ marginRight: 20 }} />
    <TextItalic css={{ color: colors.grayLight }}>{children}</TextItalic>
  </div>
);

export default GuaranteedResult;
